import { useState } from "react";
import { adminApi, formatApiError } from "@/lib/adminApi";

export const ForgotPassword = () => {
  const [state, setState] = useState({ status: "idle", message: "" });

  const request = async () => {
    setState({ status: "sending", message: "" });
    try {
      const { data } = await adminApi.post("/admin/forgot-password");
      setState({ status: "sent", message: `A reset link was sent to the studio inbox (${data.sent_to}). It expires in 30 minutes.` });
    } catch (err) {
      setState({ status: "error", message: formatApiError(err.response?.data?.detail, "We couldn't send the reset email. Please try again in a few minutes.") });
    }
  };

  return (
    <div style={{ marginTop: 18, textAlign: "center" }}>
      <button type="button" className="hx-link" onClick={request} disabled={state.status === "sending"} data-testid="admin-forgot-password-link">
        {state.status === "sending" ? "Sending reset link…" : "Forgot password?"}
      </button>
      {state.status === "sent" && <p className="hx-notice" data-testid="admin-forgot-password-success">{state.message}</p>}
      {state.status === "error" && <p className="hx-alert" style={{ marginTop: 12 }} data-testid="admin-forgot-password-error">{state.message}</p>}
    </div>
  );
};
